import { EPromotionsFormState } from 'constants/enums';

export const PROMOTIONS_TABS = [
  { label: 'Settings', value: EPromotionsFormState.GENERAL },
  { label: 'Schedule', value: EPromotionsFormState.SCHEDULE }
];
